import { Configuration, PopupRequest } from "@azure/msal-browser";
import { ROUTES } from "./routes/constants";
const { REACT_APP_AUTH_CLIENT_ID, REACT_APP_AUTH_TENANT_ID } = process.env;

export const msalConfig: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${REACT_APP_AUTH_TENANT_ID}`,
    clientId: REACT_APP_AUTH_CLIENT_ID || "common",
    postLogoutRedirectUri: null,
    redirectUri: `${window.location.origin}/${ROUTES.HOME}`,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ["openid", "api://upc-auth-scop/AdminOnly"],
};
